import { combineReducers } from "redux";
import sessionReducer, {
  SESSION_INITIAL_STATE,
} from "../reducers/session/reducers";
import { HYDRATE } from "next-redux-wrapper";
import usersReducer, { USERS_INITIAL_STATE } from "../reducers/users/reducers";
import prepFqReducer, {
  PREP_FQ_INITIAL_STATE,
} from "../reducers/prep_fq/reducers";
import asipReducer, { ASIP_INITIAL_STATE } from "../reducers/asip/reducers";
import guideReducer, { GUIDES_INITIAL_STATE } from "../reducers/guide/reducers";
import exploreGuideReducer, {
  EXPLORE_GUIDES_INITIAL_STATE,
} from "../reducers/explore_guide/reducers";
import validationReducer, {
  VALIDATION_INITIAL_STATE,
} from "../reducers/validation/reducers";

const USER_LOGOUT = "user logout";
export const userLogout = () => ({ type: USER_LOGOUT });

const appReducer = combineReducers({
  sessionState: sessionReducer,
  usersState: usersReducer,
  prepFqState: prepFqReducer,
  asipState: asipReducer,
  guideState: guideReducer,
  exploreGuideState: exploreGuideReducer,
  validationState: validationReducer,
});

export const APP_INITIAL_STATE = {
  sessionState: SESSION_INITIAL_STATE,
  usersState: USERS_INITIAL_STATE,
  prepFqState: PREP_FQ_INITIAL_STATE,
  asipState: ASIP_INITIAL_STATE,
  guideState: GUIDES_INITIAL_STATE,
  exploreGuideState: EXPLORE_GUIDES_INITIAL_STATE,
  validationState: VALIDATION_INITIAL_STATE,
};

const rootReducer = (state: any, action: any) => {
  if (action.type === HYDRATE) {
    const nextState = {
      ...state, // use previous state
      ...action.payload, // apply delta from hydration
    };
    return nextState;
  } else {
    if (action.type === USER_LOGOUT) {
      state = Object.assign({}, APP_INITIAL_STATE);
    }

    return appReducer(state, action);
  }
};

export default rootReducer;
